module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_agreable_m.f28ef38741efb364e32ec8f54004bc7b.png";